import { useState } from 'react';
import { TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { Input, Select } from '../../../../components/Basic/Inputs';
import { Button } from '../../../../components/Basic/Buttons';

const ReasonStockDebitPopUp = ({ clickOk = () => {}, close = () => {} }) => {
  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
        <H2 style={{ marginBottom: '20px' }}>Укажите причину списания</H2>
        <div style={{ height: '40px' }}>
          <Select
            label="Куда списание?"
            select={reason}
            width={'400px'}
            style={{ marginRight: '15px' }}
            list={[
              'Корректировка при занесении',
              'Корректировка при разнесении',
              'Корректировка наличия',
              'Экспресс Cбермаркет',
              'Брак товара / просрочка товара',
              'Покупка со склада',
              'Взяли для нужд склада',
              'Другое',
            ]}
            onSelect={(v) => setReason(v)}
          />
        </div>
        <Input label={'Комментарий'} value={comment} onChange={(v) => setComment(v)} />
        <Row style={{ marginTop: '40px' }}>
          <Button
            type={TYPE_BUTTONS.BLUE}
            style={{
              marginRight: '15px',
            }}
            disabled={reason === ''}
            onClick={() => clickOk(`${reason}${comment.length > 0 ? `: ${comment}` : ''}`)}
          >
            Да
          </Button>
          <Button type={TYPE_BUTTONS.GREY} onClick={close}>
            Отменить
          </Button>
        </Row>
    </PopUp>
  );
};

export default ReasonStockDebitPopUp;
